/* @flow */

import React from 'react';
import { Label } from 'semantic-ui-react';

type Props = {
  page: CatalogPage,
};

const PageTemplateLabel = ({ page }: Props) => {
  const isLocked = page.isLocked || page.template.isLocked;
  const label = isLocked ? 'Embarqué' : page.template.label;
  const color = isLocked ? 'grey' : 'green';

  return <Label color={color}>{label}</Label>;
};

export default PageTemplateLabel;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/shared/components/PageTemplateLabel.js